import React from "react";
import SchemaForm from "components/util/schema_form/SchemaForm";

const parseStructure = (structure) => {

  const parser = (type) => {
    switch(type) {
      case "string": return "TEXT";
      case "enum": return "SELECT";
      case "date": return "DATE";
      case "file": return "FILE";
      case "boolean": return "CHECKBOX";
      case "float": return "TEXT";
      default: return "string";
    }
  }

  return structure.map((field) => {
    return {
      ...field,
      type: parser(field.type)
    }
  });

}

const DataForm = ({ 
  structure, 
  initialRow = {}, 
  title, 
  onClickSubmitForm 
}) => {
  const parsedStructure = parseStructure(structure);
  return <div className="card card-body">
    {title && <h4>{title}</h4>}
    <SchemaForm
      schema={parsedStructure}
      initialValues={initialRow?.data ?? {}}
      onSubmit={onClickSubmitForm}
    />
  </div>
}

export default DataForm;